/**
 * GENERATED FILE — DO NOT EDIT.
 *
 * Produced by scripts/bakeTrajectories.mjs from the GLB clips in assets/clips/.
 * Re-run with:  npm run bake --workspace @dueler/shared
 */
export const TRAJECTORIES = {
    slash: {
        "clipId": "slash",
        "hz": 60,
        "startMs": 0,
        "durationMs": 1529.9999713897705,
        "activeStartMs": 550,
        "activeEndMs": 990,
        "positions": [
            0,
            1.221845,
            -0.512382,
            0.035917,
            1.224094,
            -0.527901,
            0.074711,
            1.231066,
            -0.54183,
            0.115642,
            1.243253,
            -0.553022,
            0.157741,
            1.26082,
            -0.560277,
            0.199846,
            1.283551,
            -0.562449,
            0.240669,
            1.310835,
            -0.558569,
            0.278877,
            1.341694,
            -0.547951,
            0.313184,
            1.37485,
            -0.530291,
            0.342459,
            1.408834,
            -0.505728,
            0.365804,
            1.442108,
            -0.474855,
            0.382637,
            1.473209,
            -0.43869,
            0.39273,
            1.500867,
            -0.398598,
            0.396231,
            1.524111,
            -0.356172,
            0.393646,
            1.542329,
            -0.313107,
            0.385795,
            1.555282,
            -0.271063,
            0.373745,
            1.563094,
            -0.231546,
            0.358732,
            1.566187,
            -0.195825,
            0.342074,
            1.565213,
            -0.16488,
            0.325082,
            1.560966,
            -0.139393,
            0.308955,
            1.554304,
            -0.119721,
            0.29516,
            1.545988,
            -0.107635,
            0.285706,
            1.536829,
            -0.108119,
            0.280682,
            1.528029,
            -0.120078,
            0.278867,
            1.520323,
            -0.141259,
            0.27855,
            1.514032,
            -0.169487,
            0.278023,
            1.509196,
            -0.2026,
            0.275956,
            1.505683,
            -0.238453,
            0.271653,
            1.50327,
            -0.275007,
            0.265155,
            1.501705,
            -0.310489,
            0.257209,
            1.500754,
            -0.343591,
            0.249103,
            1.500227,
            -0.373622,
            0.242446,
            1.499998,
            -0.40057,
            0.238685,
            1.5,
            -0.425087,
            0.236712,
            1.5,
            -0.449708,
            0.233052,
            1.5,
            -0.476249,
            0.226988,
            1.5,
            -0.504605,
            0.217765,
            1.5,
            -0.534438,
            0.204681,
            1.5,
            -0.565235,
            0.187136,
            1.5,
            -0.596297,
            0.164691,
            1.5,
            -0.626761,
            0.137114,
            1.5,
            -0.65563,
            0.104427,
            1.5,
            -0.681832,
            0.066926,
            1.5,
            -0.704289,
            0.02519,
            1.5,
            -0.721989,
            -0.019946,
            1.5,
            -0.734072,
            -0.067427,
            1.5,
            -0.739897,
            -0.116048,
            1.5,
            -0.739103,
            -0.164532,
            1.5,
            -0.731645,
            -0.211614,
            1.5,
            -0.717804,
            -0.256125,
            1.5,
            -0.698175,
            -0.297068,
            1.5,
            -0.673629,
            -0.333676,
            1.5,
            -0.645261,
            -0.365439,
            1.5,
            -0.614316,
            -0.392125,
            1.5,
            -0.582124,
            -0.413756,
            1.5,
            -0.550028,
            -0.430581,
            1.5,
            -0.519323,
            -0.443017,
            1.5,
            -0.491208,
            -0.451585,
            1.5,
            -0.466758,
            -0.456905,
            1.5,
            -0.446727,
            -0.459552,
            1.499729,
            -0.431831,
            -0.460811,
            1.499517,
            -0.420443,
            -0.46106,
            1.499505,
            -0.41237,
            -0.46051,
            1.499568,
            -0.407488,
            -0.459297,
            1.499569,
            -0.405637,
            -0.457492,
            1.499361,
            -0.406622,
            -0.455113,
            1.498797,
            -0.410227,
            -0.452135,
            1.497735,
            -0.416211,
            -0.448503,
            1.496038,
            -0.424312,
            -0.444139,
            1.493589,
            -0.434251,
            -0.438956,
            1.490285,
            -0.445735,
            -0.432866,
            1.486048,
            -0.458454,
            -0.425786,
            1.480829,
            -0.472093,
            -0.417648,
            1.474605,
            -0.486332,
            -0.408405,
            1.467385,
            -0.50085,
            -0.398034,
            1.459212,
            -0.515336,
            -0.386539,
            1.450155,
            -0.529493,
            -0.373958,
            1.440316,
            -0.543045,
            -0.360356,
            1.42982,
            -0.555742,
            -0.345829,
            1.418811,
            -0.567368,
            -0.3305,
            1.40745,
            -0.577747,
            -0.314519,
            1.395904,
            -0.586741,
            -0.298051,
            1.384344,
            -0.59426,
            -0.281281,
            1.372935,
            -0.600254,
            -0.264402,
            1.361832,
            -0.604717,
            -0.247611,
            1.351172,
            -0.607683,
            -0.231108,
            1.341073,
            -0.609222,
            -0.215085,
            1.331629,
            -0.609432,
            -0.199728,
            1.322906,
            -0.608437,
            -0.18521,
            1.314948,
            -0.606379,
            -0.171692,
            1.30777,
            -0.603409,
            -0.159319,
            1.301366,
            -0.599684
        ],
        "rotations": [
            0.224951,
            0,
            0,
            0.97437,
            0.218791,
            -0.012425,
            0.057418,
            0.974002,
            0.211908,
            -0.03208,
            0.115824,
            0.969872,
            0.204263,
            -0.059154,
            0.173743,
            0.961556,
            0.195858,
            -0.093549,
            0.229667,
            0.948758,
            0.186724,
            -0.134876,
            0.282117,
            0.931318,
            0.176927,
            -0.182462,
            0.329714,
            0.909227,
            0.166562,
            -0.235385,
            0.371242,
            0.882627,
            0.155747,
            -0.292513,
            0.405707,
            0.85181,
            0.144621,
            -0.352564,
            0.432379,
            0.81721,
            0.133337,
            -0.414173,
            0.45082,
            0.779386,
            0.122054,
            -0.475959,
            0.460898,
            0.739012,
            0.110933,
            -0.536598,
            0.462775,
            0.696846,
            0.10013,
            -0.594881,
            0.456884,
            0.653719,
            0.089789,
            -0.649762,
            0.443888,
            0.610501,
            0.080041,
            -0.700398,
            0.424635,
            0.568086,
            0.070995,
            -0.746165,
            0.400098,
            0.52737,
            -0.062736,
            0.78666,
            -0.371324,
            -0.489232,
            -0.055326,
            0.821687,
            -0.339381,
            -0.454522,
            -0.048798,
            0.851228,
            -0.305309,
            -0.424047,
            -0.043151,
            0.875438,
            -0.270077,
            -0.398503,
            -0.038442,
            0.893832,
            -0.234724,
            -0.38012,
            -0.034778,
            0.904691,
            -0.200562,
            -0.374299,
            -0.031894,
            0.908607,
            -0.168488,
            -0.380824,
            -0.029426,
            0.90627,
            -0.138977,
            -0.398112,
            -0.027028,
            0.898062,
            -0.112291,
            -0.424435,
            -0.02442,
            0.884212,
            -0.088559,
            -0.457963,
            -0.02142,
            0.864939,
            -0.067821,
            -0.496812,
            0.017964,
            -0.840567,
            0.050045,
            0.539092,
            0.014118,
            -0.811613,
            0.035133,
            0.582968,
            0.010071,
            -0.778842,
            0.022924,
            0.62672,
            0.006118,
            -0.74329,
            0.013195,
            0.668812,
            0.002636,
            -0.706252,
            0.00567,
            0.707933,
            0,
            -0.669131,
            0,
            0.743145,
            0,
            -0.630274,
            0,
            0.776373,
            0,
            -0.58696,
            0,
            0.809616,
            0,
            -0.539197,
            0,
            0.84218,
            0,
            -0.487179,
            0,
            0.873302,
            0,
            -0.431194,
            0,
            0.902259,
            0,
            -0.371621,
            0,
            0.928384,
            0,
            -0.308934,
            0,
            0.951084,
            0,
            -0.243683,
            0,
            0.969855,
            0,
            -0.176493,
            0,
            0.984302,
            0,
            -0.108037,
            0,
            0.994147,
            0,
            -0.039026,
            0,
            0.999238,
            0,
            0.029813,
            0,
            0.999555,
            0,
            0.09776,
            0,
            0.99521,
            0,
            0.164118,
            0,
            0.986441,
            0,
            0.228236,
            0,
            0.973606,
            0,
            0.289518,
            0,
            0.957173,
            0,
            0.347441,
            0,
            0.937702,
            0,
            0.401563,
            0,
            0.915831,
            0,
            0.451525,
            0,
            0.892259,
            0,
            0.49705,
            0,
            0.867722,
            0,
            0.537941,
            0,
            0.842982,
            0,
            0.574072,
            0,
            0.818805,
            0,
            0.60537,
            0,
            0.795944,
            0,
            0.631803,
            0,
            0.775129,
            0,
            0.65336,
            0,
            0.757047,
            0,
            0.670172,
            0,
            0.742206,
            0.001691,
            0.682198,
            -0.007385,
            0.731128,
            0.004641,
            0.690943,
            -0.020773,
            0.722595,
            0.007793,
            0.696649,
            -0.035492,
            0.716491,
            0.011162,
            0.699443,
            -0.051351,
            0.712754,
            0.014764,
            0.69943,
            -0.068147,
            0.711292,
            0.018616,
            0.696701,
            -0.085661,
            0.711986,
            0.022739,
            0.691334,
            -0.103669,
            0.714698,
            0.02715,
            0.683405,
            -0.121936,
            0.719272,
            0.031866,
            0.672992,
            -0.140223,
            0.725537,
            0.036904,
            0.660179,
            -0.158288,
            0.733312,
            0.042274,
            0.645063,
            -0.175888,
            0.742409,
            0.047982,
            0.627755,
            -0.192785,
            0.752632,
            0.054033,
            0.608388,
            -0.20875,
            0.763785,
            0.060424,
            0.587114,
            -0.223563,
            0.775671,
            0.067146,
            0.564107,
            -0.237024,
            0.788095,
            0.074187,
            0.539563,
            -0.248952,
            0.800869,
            0.081528,
            0.513702,
            -0.259192,
            0.813808,
            0.089145,
            0.486759,
            -0.26762,
            0.82674,
            0.09701,
            0.458989,
            -0.274143,
            0.839502,
            0.105089,
            0.430656,
            -0.278707,
            0.851947,
            0.113346,
            0.402035,
            -0.281296,
            0.863941,
            0.121741,
            0.373401,
            -0.281934,
            0.875365,
            0.130233,
            0.345027,
            -0.280686,
            0.886121,
            0.138779,
            0.317178,
            -0.277659,
            0.896127,
            0.147336,
            0.290106,
            -0.272997,
            0.905319,
            0.15586,
            0.264042,
            -0.266883,
            0.913654,
            0.164311,
            0.239195,
            -0.259531,
            0.921103,
            0.172647,
            0.215749,
            -0.251187,
            0.927659,
            0.180833,
            0.193855,
            -0.242121,
            0.933326,
            0.188833,
            0.173631,
            -0.232624,
            0.938126,
            0.196615,
            0.155165,
            -0.223004,
            0.942091,
            0.204152,
            0.138508,
            -0.213579,
            0.945263
        ],
        "source": {
            "file": "slash.glb",
            "clip": "slash",
            "weaponNode": "Weapon",
            "rootNode": "Root"
        }
    },
    stab: {
        "clipId": "stab",
        "hz": 60,
        "startMs": 0,
        "durationMs": 1330.0000429153442,
        "activeStartMs": 380,
        "activeEndMs": 610,
        "positions": [
            0,
            1.221845,
            -0.332382,
            0.006016,
            1.23244,
            -0.329832,
            0.012103,
            1.243285,
            -0.325459,
            0.018113,
            1.254308,
            -0.319605,
            0.023913,
            1.265451,
            -0.312604,
            0.02939,
            1.276661,
            -0.304784,
            0.034451,
            1.287889,
            -0.296465,
            0.039023,
            1.299093,
            -0.287958,
            0.043054,
            1.310235,
            -0.279565,
            0.046511,
            1.321284,
            -0.27158,
            0.049378,
            1.332219,
            -0.264287,
            0.051654,
            1.343033,
            -0.257961,
            0.05335,
            1.353737,
            -0.25287,
            0.054484,
            1.364364,
            -0.249274,
            0.055086,
            1.374976,
            -0.247384,
            0.054777,
            1.386762,
            -0.247875,
            0.053256,
            1.400995,
            -0.250803,
            0.050875,
            1.41701,
            -0.255718,
            0.047974,
            1.434005,
            -0.262425,
            0.044842,
            1.451101,
            -0.27112,
            0.041719,
            1.467363,
            -0.28241,
            0.038815,
            1.481819,
            -0.297272,
            0.036319,
            1.493444,
            -0.316946,
            0.034388,
            1.5,
            -0.343,
            0.032445,
            1.5,
            -0.37734,
            0.02997,
            1.5,
            -0.419438,
            0.026809,
            1.5,
            -0.467614,
            0.022861,
            1.5,
            -0.520178,
            0.018098,
            1.5,
            -0.575435,
            0.012576,
            1.5,
            -0.631691,
            0.00644,
            1.5,
            -0.68726,
            -0.00008,
            1.5,
            -0.740469,
            -0.006673,
            1.5,
            -0.789666,
            -0.01296,
            1.5,
            -0.833221,
            -0.01852,
            1.5,
            -0.869523,
            -0.022906,
            1.5,
            -0.896976,
            -0.025714,
            1.5,
            -0.914165,
            -0.026717,
            1.497842,
            -0.920463,
            -0.027122,
            1.492325,
            -0.923228,
            -0.02733,
            1.486628,
            -0.924847,
            -0.027344,
            1.480768,
            -0.925352,
            -0.027173,
            1.474765,
            -0.924775,
            -0.026823,
            1.468639,
            -0.923149,
            -0.026302,
            1.462407,
            -0.920507,
            -0.025617,
            1.456089,
            -0.916882,
            -0.024779,
            1.449705,
            -0.912309,
            -0.023796,
            1.443273,
            -0.906823,
            -0.022677,
            1.436813,
            -0.900458,
            -0.021434,
            1.430342,
            -0.89325,
            -0.020075,
            1.423879,
            -0.885237,
            -0.018611,
            1.417441,
            -0.876456,
            -0.017052,
            1.411046,
            -0.866945,
            -0.015409,
            1.40471,
            -0.856742,
            -0.013691,
            1.398449,
            -0.845888,
            -0.011909,
            1.392277,
            -0.834424,
            -0.010073,
            1.386208,
            -0.822389,
            -0.008192,
            1.380256,
            -0.809827,
            -0.006276,
            1.374433,
            -0.79678,
            -0.004334,
            1.36875,
            -0.78329,
            -0.002375,
            1.363215,
            -0.769402,
            -0.000407,
            1.357839,
            -0.75516,
            0.001561,
            1.352627,
            -0.740608,
            0.003522,
            1.347587,
            -0.725791,
            0.005468,
            1.342722,
            -0.710755,
            0.007394,
            1.338037,
            -0.695544,
            0.009291,
            1.333532,
            -0.680205,
            0.011155,
            1.329208,
            -0.664783,
            0.012981,
            1.325065,
            -0.649323,
            0.014762,
            1.321101,
            -0.633871,
            0.016496,
            1.317311,
            -0.618471,
            0.018177,
            1.313691,
            -0.603168,
            0.019803,
            1.310234,
            -0.588007,
            0.02137,
            1.306934,
            -0.573031,
            0.022876,
            1.303781,
            -0.558283,
            0.024318,
            1.300766,
            -0.543807,
            0.025695,
            1.297877,
            -0.529644,
            0.027005,
            1.295104,
            -0.515836,
            0.028246,
            1.292432,
            -0.502423,
            0.029419,
            1.289849,
            -0.489444,
            0.030522,
            1.287339,
            -0.476939
        ],
        "rotations": [
            0.224951,
            0,
            0,
            0.97437,
            0.220447,
            -0.001992,
            0.010081,
            0.975345,
            0.216457,
            -0.004852,
            0.020662,
            0.976061,
            0.212835,
            -0.008533,
            0.031527,
            0.976542,
            0.209433,
            -0.012989,
            0.042463,
            0.976814,
            0.206106,
            -0.018177,
            0.053255,
            0.97691,
            0.20271,
            -0.024056,
            0.063685,
            0.976869,
            0.199103,
            -0.030594,
            0.073528,
            0.976737,
            0.195144,
            -0.037757,
            0.082552,
            0.976565,
            0.190693,
            -0.045507,
            0.090512,
            0.976408,
            0.185613,
            -0.053793,
            0.097156,
            0.976327,
            0.179764,
            -0.062536,
            0.102223,
            0.976383,
            0.173008,
            -0.071623,
            0.105449,
            0.976637,
            0.165205,
            -0.080881,
            0.106575,
            0.977142,
            0.156231,
            -0.090077,
            0.105388,
            0.977942,
            0.144223,
            -0.099132,
            0.100155,
            0.97946,
            0.127492,
            -0.107407,
            0.089373,
            0.981948,
            0.10735,
            -0.113362,
            0.074443,
            0.984928,
            0.085266,
            -0.115833,
            0.057313,
            0.987941,
            0.062737,
            -0.114398,
            0.040084,
            0.990641,
            0.041288,
            -0.109466,
            0.02465,
            0.992827,
            0.02247,
            -0.102102,
            0.012379,
            0.994443,
            0.007813,
            -0.093704,
            0.003954,
            0.995562,
            0,
            -0.085541,
            0,
            0.996335,
            0,
            -0.076836,
            0,
            0.997044,
            0,
            -0.066972,
            0,
            0.997755,
            0,
            -0.056241,
            0,
            0.998417,
            0,
            -0.044937,
            0,
            0.99899,
            0,
            -0.033353,
            0,
            0.999444,
            0,
            -0.021785,
            0,
            0.999763,
            0,
            -0.010527,
            0,
            0.999945,
            0,
            0.000125,
            0,
            1,
            0,
            0.009875,
            0,
            0.999951,
            0,
            0.01843,
            0,
            0.99983,
            0,
            0.025496,
            0,
            0.999675,
            0,
            0.030778,
            0,
            0.999526,
            0,
            0.03402,
            0,
            0.999421,
            0.001544,
            0.035114,
            -0.000254,
            0.999382,
            0.005469,
            0.0355,
            -0.000909,
            0.999354,
            0.009501,
            0.035641,
            -0.001587,
            0.999318,
            0.013637,
            0.035546,
            -0.002273,
            0.999272,
            0.017873,
            0.035221,
            -0.002955,
            0.999215,
            0.022205,
            0.034677,
            -0.003619,
            0.999145,
            0.026628,
            0.033923,
            -0.004252,
            0.999061,
            0.031139,
            0.032968,
            -0.004842,
            0.998959,
            0.035734,
            0.031822,
            -0.005376,
            0.99884,
            0.040409,
            0.030498,
            -0.005842,
            0.998701,
            0.04516,
            0.029007,
            -0.006228,
            0.998539,
            0.049982,
            0.027361,
            -0.006525,
            0.998354,
            0.054872,
            0.025572,
            -0.006721,
            0.998143,
            0.059825,
            0.023654,
            -0.006808,
            0.997905,
            0.064838,
            0.02162,
            -0.006776,
            0.997639,
            0.069906,
            0.019484,
            -0.006619,
            0.997341,
            0.075025,
            0.017262,
            -0.00633,
            0.997012,
            0.08019,
            0.014966,
            -0.005904,
            0.99665,
            0.085399,
            0.012613,
            -0.005335,
            0.996253,
            0.090645,
            0.010216,
            -0.004622,
            0.99582,
            0.095926,
            0.007792,
            -0.00376,
            0.995351,
            0.101236,
            0.005354,
            -0.002751,
            0.994844,
            0.106572,
            0.002918,
            -0.001593,
            0.994299,
            0.111929,
            0.000497,
            -0.000288,
            0.993716,
            0.117304,
            -0.001893,
            0.001161,
            0.993094,
            0.12269,
            -0.004238,
            0.002751,
            0.992432,
            0.128086,
            -0.006527,
            0.004476,
            0.991732,
            0.133485,
            -0.008744,
            0.00633,
            0.990992,
            0.138885,
            -0.010879,
            0.008307,
            0.990214,
            0.14428,
            -0.012919,
            0.010398,
            0.989398,
            0.149668,
            -0.014855,
            0.012594,
            0.988545,
            0.155042,
            -0.016676,
            0.014885,
            0.987655,
            0.1604,
            -0.018372,
            0.017259,
            0.98673,
            0.165737,
            -0.019937,
            0.019705,
            0.985771,
            0.17105,
            -0.021363,
            0.022211,
            0.98478,
            0.176334,
            -0.022644,
            0.024762,
            0.983758,
            0.181586,
            -0.023775,
            0.027346,
            0.982707,
            0.186801,
            -0.024754,
            0.029948,
            0.981629,
            0.191976,
            -0.025576,
            0.032552,
            0.980526,
            0.197107,
            -0.02624,
            0.035145,
            0.9794,
            0.20219,
            -0.026748,
            0.03771,
            0.978254,
            0.207222,
            -0.027098,
            0.040232,
            0.977091,
            0.212199,
            -0.027294,
            0.042696,
            0.975912
        ],
        "source": {
            "file": "stab.glb",
            "clip": "stab",
            "weaponNode": "Weapon",
            "rootNode": "Root"
        }
    },
    flourish: {
        "clipId": "flourish",
        "hz": 60,
        "startMs": 0,
        "durationMs": 1100.000023841858,
        "activeStartMs": 0,
        "activeEndMs": 0,
        "positions": [
            0,
            1.221845,
            -0.512382,
            0.033098,
            1.247759,
            -0.531377,
            0.077635,
            1.276844,
            -0.546926,
            0.130553,
            1.305962,
            -0.556659,
            0.187677,
            1.332182,
            -0.559589,
            0.244127,
            1.35377,
            -0.556546,
            0.293788,
            1.371544,
            -0.550788,
            0.328931,
            1.391047,
            -0.549,
            0.360391,
            1.406186,
            -0.546169,
            0.384967,
            1.416661,
            -0.54359,
            0.394238,
            1.434279,
            -0.549206,
            0.397336,
            1.458587,
            -0.557947,
            0.397061,
            1.487201,
            -0.566486,
            0.391945,
            1.520111,
            -0.573014,
            0.37985,
            1.556922,
            -0.575646,
            0.366114,
            1.597142,
            -0.572498,
            0.350678,
            1.63916,
            -0.561779,
            0.335521,
            1.681631,
            -0.542438,
            0.322382,
            1.72263,
            -0.514051,
            0.312288,
            1.759727,
            -0.476952,
            0.306086,
            1.790587,
            -0.432385,
            0.304313,
            1.813283,
            -0.382426,
            0.307105,
            1.826576,
            -0.329757,
            0.314175,
            1.830096,
            -0.277352,
            0.325041,
            1.823841,
            -0.228339,
            0.338008,
            1.810712,
            -0.184604,
            0.353244,
            1.790633,
            -0.147032,
            0.370261,
            1.764424,
            -0.115114,
            0.388256,
            1.733629,
            -0.089994,
            0.406318,
            1.699968,
            -0.072429,
            0.42362,
            1.665213,
            -0.062667,
            0.439532,
            1.630841,
            -0.060414,
            0.453454,
            1.598273,
            -0.064994,
            0.465102,
            1.568594,
            -0.075425,
            0.474255,
            1.542529,
            -0.090534,
            0.480852,
            1.520446,
            -0.10908,
            0.484994,
            1.502374,
            -0.129867,
            0.486918,
            1.487626,
            -0.15184,
            0.486963,
            1.476063,
            -0.174156,
            0.485534,
            1.467435,
            -0.196228,
            0.483056,
            1.461017,
            -0.217988,
            0.480013,
            1.45586,
            -0.238577,
            0.477348,
            1.449589,
            -0.25897,
            0.474252,
            1.444732,
            -0.279555,
            0.471151,
            1.441468,
            -0.300069,
            0.466583,
            1.439778,
            -0.320289,
            0.462166,
            1.437689,
            -0.340592,
            0.457441,
            1.436236,
            -0.360881,
            0.45233,
            1.435459,
            -0.381099,
            0.446741,
            1.43534,
            -0.401171,
            0.440546,
            1.435852,
            -0.420992,
            0.43359,
            1.436957,
            -0.440424,
            0.425696,
            1.438602,
            -0.4593,
            0.415954,
            1.440717,
            -0.47742,
            0.400489,
            1.443322,
            -0.494549,
            0.382135,
            1.445888,
            -0.510414,
            0.35981,
            1.4479,
            -0.524695,
            0.332915,
            1.44864,
            -0.537034,
            0.297957,
            1.443638,
            -0.547286,
            0.255532,
            1.430724,
            -0.555141,
            0.208906,
            1.409891,
            -0.560006,
            0.161789,
            1.382029,
            -0.561273,
            0.117655,
            1.349072,
            -0.558519,
            0.079048,
            1.313796,
            -0.551661,
            0.047078,
            1.279267,
            -0.54106,
            0.021296,
            1.248103,
            -0.527547,
            0,
            1.221845,
            -0.512382
        ],
        "rotations": [
            0.224951,
            0,
            0,
            0.97437,
            0.206329,
            -0.02205,
            -0.024869,
            0.977918,
            0.1823,
            -0.05515,
            -0.0487,
            0.980486,
            0.150985,
            -0.098589,
            -0.077011,
            0.980588,
            0.111751,
            -0.148038,
            -0.114028,
            0.976009,
            0.066376,
            -0.196599,
            -0.161339,
            0.964838,
            0.020623,
            -0.233877,
            -0.219894,
            0.946849,
            -0.012692,
            -0.242042,
            -0.292874,
            0.924921,
            -0.039971,
            -0.244816,
            -0.353042,
            0.902125,
            -0.059745,
            -0.244563,
            -0.397212,
            0.88252,
            -0.055762,
            -0.216085,
            -0.439928,
            0.869863,
            -0.037476,
            -0.171196,
            -0.480229,
            0.859458,
            -0.01057,
            -0.118614,
            -0.513815,
            0.849596,
            0.023959,
            -0.059364,
            -0.536546,
            0.841439,
            0.063775,
            0.005827,
            -0.550389,
            0.832449,
            0.108506,
            0.074652,
            -0.559749,
            0.818129,
            0.155844,
            0.146054,
            -0.565424,
            0.796666,
            0.202382,
            0.219981,
            -0.566846,
            0.767682,
            0.248391,
            0.293963,
            -0.563307,
            0.731145,
            0.292817,
            0.366363,
            -0.554567,
            0.687381,
            0.334689,
            0.435627,
            -0.540663,
            0.637099,
            0.373174,
            0.50037,
            -0.521909,
            0.581362,
            0.40762,
            0.559448,
            -0.498879,
            0.52152,
            0.437595,
            0.611983,
            -0.472486,
            0.459069,
            0.462789,
            0.657386,
            -0.444204,
            0.395415,
            0.483439,
            0.69595,
            -0.41311,
            0.333588,
            0.500286,
            0.72848,
            -0.381135,
            0.271602,
            0.514041,
            0.756639,
            -0.346709,
            0.207489,
            0.524598,
            0.780115,
            -0.309988,
            0.141864,
            0.531703,
            0.798647,
            -0.271698,
            0.075069,
            0.535298,
            0.811972,
            -0.232597,
            0.007459,
            0.53559,
            0.819771,
            -0.193497,
            -0.060642,
            0.531785,
            0.822652,
            -0.154796,
            -0.128399,
            0.524459,
            0.820573,
            -0.116441,
            -0.19505,
            0.513925,
            0.813684,
            -0.078715,
            -0.260008,
            0.500447,
            0.802287,
            -0.041877,
            -0.322699,
            0.484337,
            0.78676,
            -0.006149,
            -0.382608,
            0.465942,
            0.767547,
            0.028276,
            -0.439284,
            0.445633,
            0.74515,
            0.06124,
            -0.492354,
            -0.423801,
            -0.720112,
            -0.092611,
            0.54153,
            -0.400844,
            -0.693009,
            -0.122286,
            0.586608,
            -0.377162,
            -0.664432,
            -0.150196,
            0.627472,
            -0.354017,
            -0.63453,
            -0.178435,
            0.663479,
            -0.331899,
            -0.60344,
            -0.207988,
            0.694582,
            -0.309771,
            -0.571887,
            -0.237185,
            0.721617,
            -0.287246,
            -0.540182,
            -0.264937,
            0.74532,
            -0.264698,
            -0.508214,
            -0.291244,
            0.766049,
            -0.242099,
            -0.47609,
            -0.315763,
            0.784232,
            -0.219414,
            -0.443926,
            -0.338261,
            0.800229,
            -0.196605,
            -0.411839,
            -0.358608,
            0.814332,
            -0.173628,
            -0.37995,
            -0.376779,
            0.826758,
            -0.150438,
            -0.34838,
            -0.392846,
            0.837659,
            -0.126987,
            -0.317245,
            -0.406973,
            0.847114,
            -0.103229,
            -0.286665,
            -0.419412,
            0.855138,
            -0.077294,
            -0.257316,
            -0.424359,
            0.864716,
            -0.050076,
            -0.228712,
            -0.423233,
            0.875247,
            -0.022408,
            -0.200503,
            -0.418039,
            0.885743,
            0.005502,
            -0.172727,
            -0.408504,
            0.896247,
            0.034023,
            -0.14844,
            -0.386543,
            0.909611,
            0.06266,
            -0.127669,
            -0.35163,
            0.925273,
            0.090821,
            -0.108903,
            -0.306914,
            0.941114,
            0.118066,
            -0.090887,
            -0.255276,
            0.955319,
            0.143956,
            -0.072744,
            -0.199629,
            0.966506,
            0.16801,
            -0.054091,
            -0.143053,
            0.973849,
            0.189747,
            -0.035134,
            -0.088777,
            0.97718,
            0.208787,
            -0.016674,
            -0.04005,
            0.976998,
            0.224951,
            0,
            0,
            0.97437
        ],
        "source": {
            "file": "flourish.glb",
            "clip": "flourish",
            "weaponNode": "Weapon",
            "rootNode": "Root"
        }
    },
    bow: {
        "clipId": "bow",
        "hz": 60,
        "startMs": 0,
        "durationMs": 1500,
        "activeStartMs": 0,
        "activeEndMs": 0,
        "positions": [
            0,
            1.221845,
            -0.512382,
            0.014781,
            1.221284,
            -0.510955,
            0.030026,
            1.221022,
            -0.509398,
            0.045665,
            1.221083,
            -0.507704,
            0.061627,
            1.221487,
            -0.505872,
            0.077837,
            1.22225,
            -0.503898,
            0.094221,
            1.223382,
            -0.501785,
            0.110704,
            1.224888,
            -0.499535,
            0.127209,
            1.226767,
            -0.497155,
            0.143662,
            1.229013,
            -0.494651,
            0.159987,
            1.231613,
            -0.492033,
            0.176112,
            1.234548,
            -0.489313,
            0.191965,
            1.237795,
            -0.486504,
            0.207476,
            1.241323,
            -0.483619,
            0.22258,
            1.245099,
            -0.480676,
            0.237212,
            1.249081,
            -0.477692,
            0.251312,
            1.253227,
            -0.474683,
            0.264825,
            1.257487,
            -0.471668,
            0.277695,
            1.261811,
            -0.468667,
            0.289873,
            1.266143,
            -0.465697,
            0.301314,
            1.270427,
            -0.462779,
            0.311972,
            1.274604,
            -0.45993,
            0.321807,
            1.278614,
            -0.457169,
            0.330782,
            1.282397,
            -0.454515,
            0.338866,
            1.285762,
            -0.451966,
            0.346102,
            1.288735,
            -0.449468,
            0.352551,
            1.291402,
            -0.447024,
            0.358274,
            1.293769,
            -0.444643,
            0.363326,
            1.295843,
            -0.442331,
            0.36776,
            1.297635,
            -0.440095,
            0.371629,
            1.299162,
            -0.437942,
            0.374981,
            1.300442,
            -0.435876,
            0.377864,
            1.301493,
            -0.433902,
            0.380325,
            1.302339,
            -0.432024,
            0.382409,
            1.303003,
            -0.430247,
            0.384161,
            1.303511,
            -0.428575,
            0.385623,
            1.303888,
            -0.427011,
            0.386839,
            1.304162,
            -0.425559,
            0.387852,
            1.304361,
            -0.424223,
            0.388704,
            1.304513,
            -0.423008,
            0.389389,
            1.304648,
            -0.421917,
            0.39002,
            1.304794,
            -0.420955,
            0.39065,
            1.304982,
            -0.420124,
            0.391306,
            1.305241,
            -0.41943,
            0.392012,
            1.305603,
            -0.418877,
            0.392795,
            1.306097,
            -0.418468,
            0.392795,
            1.306097,
            -0.418538,
            0.392795,
            1.306097,
            -0.418743,
            0.392795,
            1.306097,
            -0.419072,
            0.392795,
            1.306097,
            -0.419518,
            0.392795,
            1.306097,
            -0.420071,
            0.392795,
            1.306097,
            -0.420722,
            0.392795,
            1.306097,
            -0.421462,
            0.392795,
            1.306097,
            -0.422283,
            0.392795,
            1.306097,
            -0.423175,
            0.392572,
            1.306097,
            -0.424129,
            0.392216,
            1.306097,
            -0.425136,
            0.391737,
            1.306097,
            -0.426188,
            0.391121,
            1.306097,
            -0.427275,
            0.390352,
            1.306097,
            -0.428388,
            0.389415,
            1.306097,
            -0.429519,
            0.388294,
            1.306097,
            -0.430657,
            0.386974,
            1.306097,
            -0.431796,
            0.385439,
            1.306097,
            -0.432924,
            0.383675,
            1.306097,
            -0.434034,
            0.381666,
            1.306097,
            -0.435116,
            0.379396,
            1.306097,
            -0.436162,
            0.376851,
            1.306097,
            -0.437162,
            0.374014,
            1.306097,
            -0.438107,
            0.367893,
            1.30333,
            -0.440087,
            0.358585,
            1.29817,
            -0.443039,
            0.347899,
            1.29244,
            -0.446283,
            0.335887,
            1.286276,
            -0.449783,
            0.322606,
            1.279814,
            -0.453504,
            0.308121,
            1.273191,
            -0.457406,
            0.292504,
            1.266541,
            -0.461449,
            0.275839,
            1.259992,
            -0.465591,
            0.258218,
            1.253665,
            -0.469788,
            0.239746,
            1.247669,
            -0.473996,
            0.220538,
            1.242104,
            -0.478172,
            0.200717,
            1.237054,
            -0.482272,
            0.180418,
            1.232589,
            -0.486257,
            0.159778,
            1.228761,
            -0.49009,
            0.138944,
            1.225608,
            -0.493736,
            0.118063,
            1.223146,
            -0.497166,
            0.097284,
            1.221377,
            -0.500359,
            0.076758,
            1.220285,
            -0.503296,
            0.056628,
            1.219839,
            -0.505967,
            0.037036,
            1.219991,
            -0.508369,
            0.018117,
            1.220684,
            -0.510504,
            0,
            1.221845,
            -0.512382
        ],
        "rotations": [
            0.224951,
            0,
            0,
            0.97437,
            0.232233,
            -0.002323,
            0.015736,
            0.97253,
            0.239526,
            -0.00437,
            0.031956,
            0.970354,
            0.246806,
            -0.006111,
            0.048588,
            0.967827,
            0.254049,
            -0.007521,
            0.065557,
            0.964938,
            0.26123,
            -0.00858,
            0.082789,
            0.961681,
            0.268328,
            -0.00927,
            0.100207,
            0.958057,
            0.27532,
            -0.009579,
            0.117734,
            0.954068,
            0.282187,
            -0.0095,
            0.135294,
            0.949724,
            0.288911,
            -0.009031,
            0.152809,
            0.945039,
            0.295475,
            -0.008174,
            0.170203,
            0.940031,
            0.301864,
            -0.006934,
            0.187401,
            0.934725,
            0.308068,
            -0.005324,
            0.204328,
            0.929148,
            0.314076,
            -0.003359,
            0.220911,
            0.923333,
            0.319882,
            -0.001059,
            0.237081,
            0.917315,
            0.325482,
            0.001553,
            0.252767,
            0.911136,
            0.330873,
            0.004448,
            0.267904,
            0.904837,
            0.336057,
            0.007595,
            0.282428,
            0.898467,
            0.341037,
            0.010961,
            0.296276,
            0.892073,
            0.34582,
            0.014509,
            0.309391,
            0.885706,
            0.350414,
            0.018198,
            0.321716,
            0.879419,
            0.354829,
            0.021988,
            0.333197,
            0.873265,
            0.35908,
            0.025836,
            0.343783,
            0.867299,
            0.363178,
            0.029696,
            0.353423,
            0.861575,
            0.367172,
            0.033541,
            0.36207,
            0.856134,
            0.371189,
            0.037401,
            0.369723,
            0.850955,
            0.375239,
            0.041257,
            0.376444,
            0.84604,
            0.379312,
            0.045086,
            0.382302,
            0.841388,
            0.383398,
            0.048866,
            0.387363,
            0.836999,
            0.387486,
            0.052578,
            0.39169,
            0.832868,
            0.391563,
            0.056206,
            0.395349,
            0.828987,
            0.395613,
            0.059734,
            0.398402,
            0.825347,
            0.399623,
            0.063149,
            0.400913,
            0.821938,
            0.403575,
            0.066441,
            0.402944,
            0.818748,
            0.407453,
            0.069602,
            0.404556,
            0.815765,
            0.411237,
            0.072625,
            0.40581,
            0.812975,
            0.414908,
            0.075505,
            0.406767,
            0.810365,
            0.418446,
            0.07824,
            0.407486,
            0.807921,
            0.421831,
            0.080829,
            0.408028,
            0.805629,
            0.425042,
            0.083272,
            0.408451,
            0.803476,
            0.428056,
            0.085572,
            0.408815,
            0.801446,
            0.430851,
            0.087732,
            0.409178,
            0.799527,
            0.433405,
            0.089755,
            0.409599,
            0.797705,
            0.435694,
            0.091649,
            0.410136,
            0.795964,
            0.437696,
            0.093418,
            0.410846,
            0.794293,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.439387,
            0.095068,
            0.411787,
            0.792675,
            0.437502,
            0.091605,
            0.406839,
            0.79667,
            0.433796,
            0.08515,
            0.397295,
            0.804193,
            0.429362,
            0.077987,
            0.38617,
            0.812674,
            0.424178,
            0.070289,
            0.373513,
            0.821961,
            0.418224,
            0.06223,
            0.35938,
            0.831903,
            0.411484,
            0.053988,
            0.343833,
            0.842345,
            0.403951,
            0.045737,
            0.326947,
            0.853134,
            0.395627,
            0.037645,
            0.308809,
            0.864118,
            0.386525,
            0.029871,
            0.289518,
            0.875149,
            0.376672,
            0.022564,
            0.269188,
            0.886085,
            0.366103,
            0.015859,
            0.247947,
            0.896794,
            0.354871,
            0.009872,
            0.225933,
            0.907151,
            0.343038,
            0.004703,
            0.203301,
            0.917045,
            0.330679,
            0.000428,
            0.180211,
            0.926377,
            0.317882,
            -0.002897,
            0.156833,
            0.935065,
            0.304741,
            -0.005242,
            0.133345,
            0.94304,
            0.291362,
            -0.006601,
            0.109924,
            0.950253,
            0.277856,
            -0.006989,
            0.086751,
            0.956672,
            0.264342,
            -0.00645,
            0.064002,
            0.962281,
            0.250938,
            -0.005045,
            0.041851,
            0.967085,
            0.237766,
            -0.002861,
            0.020464,
            0.971103,
            0.224951,
            0,
            0,
            0.97437
        ],
        "source": {
            "file": "bow.glb",
            "clip": "bow",
            "weaponNode": "Weapon",
            "rootNode": "Root"
        }
    },
};
//# sourceMappingURL=trajectories.js.map